import { render, staticRenderFns } from "./TaxesPanel.vue?vue&type=template&id=6fdc357d&scoped=true&"
import script from "./TaxesPanel.vue?vue&type=script&lang=ts&"
export * from "./TaxesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./TaxesPanel.vue?vue&type=style&index=0&id=6fdc357d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc357d",
  null
  
)

export default component.exports
import {QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTd})
